import { FeaturesModuleType } from "UidispatcherApiModule";
const { Features }: { Features: FeaturesModuleType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default Features;
